import ModelPreference from './ModelPreference';

export default ModelPreference;
